import { DropdownButtonType, List, ListItem } from '@tableau/widgets';
import React from 'react';
import { useState } from 'react';

import { FormikSingleSelectDropdown } from '~commonInfra/components/FormikSingleSelectDropdown';

import { Messages } from '../../../../../codegen/Localize';
import { ILanguage } from '../../../../../httpClient/serverApi/types/ILanguage';
import { ILocale } from '../../../../../httpClient/serverApi/types/ILocale';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { UpdateStringServerSettingNames } from '../../../../ServerApi/requests/serverSettings/UpdateStringServerSettingRequest';
import { ServerSettingsInstance } from '../../../../services/ServerSettings';
import { dropdownListStyle, SettingsTableStyles } from '../../../../styles/CommonStyles';
import { LanguagesInstance } from '../../../resources/unownedSettings/Languages';
import { LocalesInstance } from '../../../resources/unownedSettings/Locales';
import { ServerSettingsProps } from '../../server-settings/ReactServerSettings';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';

export const LANGUAGE_FIELD = 'settings.defaultLanguage';
export const LOCALE_FIELD = 'settings.defaultLocale';

export type LanguageAndLocaleSectionProps = ServerSettingsProps<'defaultLanguage' | 'defaultLocale'>;

export function LanguageAndLocaleSection(props: LanguageAndLocaleSectionProps) {
  const [languagesList, setLanguagesList] = useState([]);
  const [localesList, setLocalesList] = useState([]);
  React.useEffect(() => {
    let isMounted = true;
    LanguagesInstance.getAll()
      .then((languages: ILanguage[]) => {
        const languageDisplayNames: ListItem[] = languages.map((language: ILanguage) => ({
          content: language.displayName,
          value: language.language,
          testId: language.language
        }));
        isMounted && setLanguagesList(languageDisplayNames);
      });
    LocalesInstance.getAll()
      .then((locales: ILocale[]) => {
        const localeDisplayNames: ListItem[] = locales.map((locale: ILocale) => ({
          content: locale.displayName,
          value: locale.locale,
          testId: locale.locale
        }));
        isMounted && setLocalesList(localeDisplayNames);
    });
    return () => isMounted = false;
  }, []);
  return <SettingsSection title={Messages.languageAndLocale()}
                          description={''}
                          testId={'language-locale-setting-section'}>
            <table><tbody>
              <tr>
                <td className={SettingsTableStyles.inputLabelCell}>
                  {Messages.language()}
                </td>
                <td className={SettingsTableStyles.inputControlCell}>
                  <FormikSingleSelectDropdown
                    name= {LANGUAGE_FIELD}
                    type={DropdownButtonType.Outline}
                    list={<List items={languagesList} className={dropdownListStyle}/>}
                    label={''}
                    testId={'default-language'}
                  />
                </td>
              </tr>
              <tr>
              <td className={SettingsTableStyles.inputLabelCell}>
                  {Messages.locale()}
              </td>
              <td className={SettingsTableStyles.inputControlCell}>
                <FormikSingleSelectDropdown
                name= {LOCALE_FIELD}
                type={DropdownButtonType.Outline}
                list={<List items={localesList} className={dropdownListStyle}/>}
                label={''}
                testId={'default-locale'}
                />
              </td>
            </tr>
          </tbody></table>
        </SettingsSection>;
}

export const LanguageAndLocaleSectionSpecs = componentRegistryEntry({
  name: 'LanguageAndLocaleSection',
  component: LanguageAndLocaleSection,
  onSubmit: async (settings) => {
    await Promise.all([
      ServerSettingsInstance.updateString(UpdateStringServerSettingNames.defaultLanguage, settings.defaultLanguage),
      ServerSettingsInstance.updateString(UpdateStringServerSettingNames.defaultLocale, settings.defaultLocale),
    ]);
  }
});
